import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { EnrollmentService } from 'src/app/private/services/enrollment.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-bulk-delete-enrollment',
  imports: [SharedModule],
  templateUrl: './bulk-delete-enrollment.component.html',
  styleUrl: './bulk-delete-enrollment.component.scss'
})
export class BulkDeleteEnrollmentComponent {


  @Output() closeDialog = new EventEmitter();
  @Input() selectedProducts: any[] = [];
  @Output() reload = new EventEmitter<any>();
  isLoading = false;

  constructor(
    private localStorage: LocalStorageService,
    private api: EnrollmentService,
    private messageService: MessageService

  ) { }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  ngOnInit() {
    // remove Moved status from selected products if exists
    this.selectedProducts = this.selectedProducts.filter(item => item.enrollment_data?.enrollment_status !== 'Moved');
  }

  handleDelete() {

    const payload: any[] = [];
    this.selectedProducts.forEach((item) => {
      payload.push({
        organization_id: this.localStorage.getOrganizationId(),
        lead_id: item.lead_id,
        enrollment_id: item.enrollment_data?.enrollment_id
      });
    });

    this.isLoading = true;
    this.api.deleteEnrollment(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.closeDialog.emit();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: response.message
        });
      },
      error: (error) => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.error.message
        });
      }

    }
    );
  }
}
